export function isFiveScoreQuestionType(questionType?: string): boolean {
    return questionType ? ['csat', 'fivestar'].includes(questionType) : false
}

export const MINIMUM_RESPONSE_THRESHOLD = 15
